import * as actionTypes from 'modules/interventions/actionTypes';

/** @typedef {'slotAssigned' | 'endDate' | 'conflict' | 'default'} ErrorType */

/**
 * @param {number} status
 * @returns {boolean}
 */
export const isCustomError = status => status === 422 || status === 409;

/**
 * @param {string} errorMessage
 * @returns {ErrorType}
 */
export const getErrorType = (errorMessage = '') => {
  const [baseError] = errorMessage.split('\n');

  // Example [uuid] cannot archive intervention - selfService with slot assigned
  if (errorMessage.endsWith('selfService with slot assigned')) {
    return 'slotAssigned';
  }

  // Example - could not validate request body due to: ValidationError: endDate must be greater than {date}
  if (baseError.startsWith('could not validate request body') && baseError.includes('endDate')) {
    return 'endDate';
  }

  // Example: [uuid] - cannot update advice [uuid] in status [PENDING] - current version [1] - received version [0]
  return 'conflict';
};

/** @type {Record<string, Record<ErrorType, import('modules/toast-notifications/types').Notification>>} */
export const ERRORS_MESSAGES = {
  [actionTypes.DELETE_INTERVENTION_FAILURE]: {
    slotAssigned: {
      message: {
        id: 'page.fiche.notification.update_intervention.error.slotAssignedDelete',
        defaultMessage: 'You cannot delete this file because a kiosk is in use.',
      },
    },
  },
  [actionTypes.UPDATE_INTERVENTION_STATUS_FAILURE]: {
    slotAssigned: {
      message: {
        id: 'page.fiche.notification.update_intervention.error.slotAssignedPatchStatus',
        defaultMessage: 'You cannot archive this file because a kiosk is in use.',
      },
    },
  },
  [actionTypes.UPDATE_INTERVENTION_FAILURE]: {
    endDate: {
      message: {
        id: 'page.fiche.notification.update_intervention.error.endDate',
        defaultMessage: 'Start date cannot be after end date',
      },
    },
    conflict: {
      message: {
        id: 'page.fiche.notification.update_intervention.conflictVersion.title',
        defaultMessage: 'Conflict error',
      },
      description: {
        id: 'page.fiche.notification.update_intervention.conflictVersion.description',
        defaultMessage:
          'You cannot save your file because it was modified in the meantime. Please reload your page before applying modifications.',
      },
      refresh: true,
    },
    default: {
      message: {
        id: 'page.fiche.notification.update_intervention.failure',
        defaultMessage: "Can't update the file",
      },
    },
  },
};
